// Relativ default → nginx proxar /api → server oavsett domän (prod bakom Coolify).
// För lokal dev: sätt REACT_APP_API_URL=http://localhost:3001/api (eller använd
// CRA-proxyn i package.json).
const API_URL = process.env.REACT_APP_API_URL || '/api';

export const createFarm = async (farmData) => {
  const response = await fetch(`${API_URL}/farms`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(farmData),
  });
  if (!response.ok) throw new Error('Failed to create farm');
  return response.json();
};

export const updateFarmBoundary = async (farmId, geoJson) => {
  const response = await fetch(`${API_URL}/farms/${farmId}/boundary`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ geometry: geoJson.geometry }),
  });
  if (!response.ok) throw new Error('Failed to update boundary');
  return response.json();
};

export const createForestStand = async (farmId, standData) => {
  const response = await fetch(`${API_URL}/stands`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ ...standData, farm_id: farmId }),
  });
  if (!response.ok) throw new Error('Failed to create stand');
  return response.json();
};

export const getForestStands = async (farmId) => {
    const response = await fetch(`${API_URL}/stands/farm/${farmId}`);
    if (!response.ok) throw new Error('Failed to fetch forest stands');
    return response.json();
};

export const getFarms = async () => {
    const response = await fetch(`${API_URL}/farms`);
    if (!response.ok) throw new Error('Failed to fetch farms');
    return response.json();
};

export const updateForestStand = async (id, data) => {
    const response = await fetch(`${API_URL}/stands/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Failed to update forest stand');
    return response.json();
};

export const deleteForestStand = async (id) => {
    const response = await fetch(`${API_URL}/stands/${id}`, {
        method: 'DELETE'
    });
    if (!response.ok) throw new Error('Failed to delete forest stand');
    return response.json();
};
export const createActivity = async (activityData, financialData = []) => {
    const response = await fetch(`${API_URL}/activities`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ activityData, financialData })
    });
    if (!response.ok) throw new Error('Failed to create activity');
    return response.json();
};

export const getActivitiesByStand = async (standId) => {
    const response = await fetch(`${API_URL}/activities/stand/${standId}`);
    if (!response.ok) throw new Error('Failed to fetch activities for stand');
    return response.json();
};

export const getActivitiesByFarm = async (farmId) => {
    const response = await fetch(`${API_URL}/activities/farm/${farmId}`);
    if (!response.ok) throw new Error('Failed to fetch activities for farm');
    return response.json();
};

export const updateActivity = async (id, activityData, financialData = null) => {
    const response = await fetch(`${API_URL}/activities/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ activityData, financialData })
    });
    if (!response.ok) throw new Error('Failed to update activity');
    return response.json();
};

export const deleteActivity = async (id) => {
    const response = await fetch(`${API_URL}/activities/${id}`, {
        method: 'DELETE'
    });
    if (!response.ok) throw new Error('Failed to delete activity');
    return response.json();
};

export const getUserSettings = async (userId) => {
    const response = await fetch(`${API_URL}/settings/${userId}`);
    if (!response.ok) throw new Error('Failed to fetch user settings');
    return response.json();
};

export const updateUserSettings = async (userId, settings) => {
    const response = await fetch(`${API_URL}/settings/${userId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(settings)
    });
    if (!response.ok) throw new Error('Failed to update user settings');
    return response.json();
};

export const getStandSpecies = async (standId) => {
    const response = await fetch(`${API_URL}/stands/${standId}/species`);
    if (!response.ok) throw new Error('Failed to fetch stand species');
    return response.json();
};

export const updateStandSpecies = async (standId, species) => {
    const response = await fetch(`${API_URL}/stands/${standId}/species`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ species })
    });
    if (!response.ok) throw new Error('Failed to update stand species');
    return response.json();
};
